export function setMembershipProfile(state, membership){
    state.userMembership = membership
}

export function removeMembershipProfile(state) {
    state.userMembership = {}
    localStorage.removeItem("affiliationProfile");
}